
        var result = require("!!../../../../../../node_modules/css-loader/index.js!./edit-default-sheet.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/whitelabels/whitelabel-configs/edit-default/edit-default-sheet.css
// module id = 696
// module chunks = 0